import { differenceInMinutes, format } from "date-fns";
import React, { useEffect, useState } from "react";
import { Exercise } from "../../../models/Exercise";
import "./style.scss";
import { AiOutlineClockCircle } from "react-icons/ai";
import { BsPeople } from "react-icons/bs";
import "../../../../style/block.scss";
import "../../../../style/buttons.scss";
import "../../../../style/feature.scss";
import "../../../../style/hovers.scss";
import useGetTicketAndPasses from "../../../../utils/hooks/useGetTicketAndPasses";
import useSchedule from "../hooks/useSchedule";
import SingleAlertsExercise from "./status";
import { useTranslation } from "react-i18next";
import SingleExerciseDetailsModal from "./SingleExerciseDetailsModal";
import SingleExerciseTicketModal from "./SingleExerciseTicketModal";

interface IProps {
  exercise: Exercise;
  onRefreshExercises: () => void;
}

const SingleExercise: React.FC<IProps> = ({ exercise, onRefreshExercises }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openModalTicket, setOpenModalTicket] = useState(false);
  const { ticketAccess, getTicketAccess } = useSchedule();

  const handleModals = (value: string) => {
    if (value === "exerciseInfoModal") {
      setOpen(true);
      setOpenModalTicket(false);
    }
    if (value === "ticketsModal") {
      setOpenModalTicket(true);
      setOpen(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const { getTicketsByExercise, tickets } = useGetTicketAndPasses();

  const updateTicketAccess = () => {
    getTicketAccess(exercise);
  };

  return (
    <React.Fragment>
      <React.Fragment>
        <div className={exercise.status === "A" ? "single-exercise" : "single-exercise single-exercise-past"}>
          <div className="exercise-line" style={{ backgroundColor: `${exercise.buttonCollor}` }}></div>
          <div className="exercise-content">
            <div className="alerts-line">
              <SingleAlertsExercise
                waitList={exercise.waitList}
                assigned={exercise.assigned}
                startTime={exercise.startTime}
                saleFrom={exercise.saleFrom}
                status={exercise.status}
              />
            </div>

            <div className="flex-between-center">
              <b className="flex-start-center">
                <AiOutlineClockCircle className="icon" style={{ color: `${exercise.buttonCollor}` }} />
                {format(exercise.startTime, "HH:mm")}
              </b>
              <b  >{differenceInMinutes(exercise.closeTime, exercise.startTime)} min.</b>
            </div>
            <strong dangerouslySetInnerHTML={{ __html: exercise.name }}></strong>

            <div className="flex-between-center footer-buttons">
              <button
                style={{ backgroundColor: `${exercise.buttonCollor}`, borderColor: `${exercise.buttonCollor}` }}
                className=" move-up button small padding-small button-fill-main"
                onClick={() => {
                  handleModals("exerciseInfoModal");
                  getTicketsByExercise(exercise.exerciseGroup.objectId);
                  updateTicketAccess();
                }}
              >
                {t("sprawdz")}
              </button>
              <b className="flex-start-center">
                <BsPeople className="icon" style={{ color: `${exercise.buttonCollor}` }} />
                {exercise.reserved + exercise.prereservation}/{exercise.capacity}
              </b>
            </div>
          </div>

          <div className="background-overlay" style={{ backgroundColor: `${exercise.buttonCollor}` }}></div>
        </div>

        {open && (
          <SingleExerciseDetailsModal
            exercise={exercise}
            onClose={handleClose}
            ticketsListLength={tickets.length}
            handleModals={handleModals}
            onRefreshExercises={onRefreshExercises}
          />
        )}

        {openModalTicket && (
          <SingleExerciseTicketModal
            exercise={exercise}
            onClose={() => setOpenModalTicket(false)}
            tickets={tickets}
            ticketAccess={ticketAccess}
          />
        )}
      </React.Fragment>
    </React.Fragment>
  );
};

export default SingleExercise;
